import packageInfo from '../../package.json';

export const environment = {
  version: packageInfo.version,
  name: packageInfo.name,
  production: false,
  pwa: true,
  updatePollRate: 30 * 60 * 1000,

  debug: true,
  environment: 'CI',
  configurationUrl: '/p1/global/config',
  apiEndpoints: {},
  urlRedirectDisabled: false,
  faroEnable: false,
  faroURL: '',
  faroApiKey: '',
  featureFlags: [],
  manifestURL: 'assets/federation.manifest.json',
  initHubServices: true,
  primaryNavHidden: false,
  authEnabled: true
};
